module.exports = __webpack_public_path__ + "static/HUB0-2a779d3b29c8f7f3873e0f65eb510151.png";